import { BuildingOfficeIcon, RocketLaunchIcon } from '@heroicons/react/24/outline';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import { Firm } from '../../../../types/firm';
import OnboardingSidebar from '../../OnboardingSidebar';
import OnboardingStepPreview from '../../OnboardingStepPreview';
import FirmDetails from './FirmDetails';
import WelcomeVideo from './WelcomeVideo';

type NewFirmFlowProps = {
    onJoin: () => void;
};

function NewFirmFlow({ onJoin }: NewFirmFlowProps): JSX.Element {
    const [step, setStep] = useState(1);
    const [firm, setFirm] = useState<Firm>();

    function next(): void {
        setStep(step === 2 ? 1 : step + 1);
    }

    function redirectToFirm(): void {
        if (!firm) {
            return;
        }
        window.location.href = `/${firm.shortId}`;
    }

    return (
        <>
            <OnboardingSidebar>
                <OnboardingStepPreview
                    active={step === 1}
                    title="Your firm"
                    description={'Provide details of your firm'}
                    icon={<BuildingOfficeIcon />}
                />

                <div className="w-[1px] bg-borderPrimary h-8 ml-[18px]"></div>
                {/* Welcome Video */}
                <OnboardingStepPreview
                    active={step === 2}
                    title="Welcome to Cimplico Workpapers!"
                    description="Check out a 5 minute overview"
                    icon={<RocketLaunchIcon />}
                />
            </OnboardingSidebar>
            <AnimatePresence exitBeforeEnter initial={false}>
                {step === 1 && (
                    <motion.div exit={{ opacity: 0, y: -5 }} transition={{ duration: 0.25 }} key="step-1">
                        <FirmDetails
                            onNext={(firm): void => {
                                setFirm(firm);
                                next();
                            }}
                            onJoin={onJoin}
                        />
                    </motion.div>
                )}
                {step === 2 && (
                    <motion.div exit={{ opacity: 0, y: -5 }} transition={{ duration: 0.25 }} key="step-2">
                        <WelcomeVideo onNext={redirectToFirm} />
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
}

export default NewFirmFlow;
